import { BFFBaseFilter, BFFBaseSort } from '../api';
import { DEFAULT_PAGE_INFO, PageInfo } from '../models/page-info';
import {
  AdvancedFilterModel,
  ColumnState,
  FilterModel,
  SortModelItem
} from 'ag-grid-enterprise';

export interface PageState {
  pageInfo: PageInfo | null;
  sortModel: BFFBaseSort | SortModelItem | null;
  filterModel: BFFBaseFilter | FilterModel | AdvancedFilterModel | null;
  columns: ColumnState[] | null;
}

export const DEFAULT_PAGE_STATE: PageState = {
  pageInfo: DEFAULT_PAGE_INFO.pageInfo,
  sortModel: null,
  filterModel: null,
  columns: []
};
